import { render, staticRenderFns } from "./OpportunityChart.vue?vue&type=template&id=01b349d0"
import script from "./OpportunityChart.vue?vue&type=script&lang=js"
export * from "./OpportunityChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports